document.querySelectorAll('.PDP_object_tab_ingredient_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: 4,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        breakpoints: {
            0: {
                freeMode: !1,
                slidesPerView: "auto"
            },
            750: {
                slidesPerView: 4,
                spaceBetween: 12,
            },
            990: {
                spaceBetween: 16,
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.matchMedia("(max-width: 750px)");

  function initMobileBehavior() {
    const containers = document.querySelectorAll(".Ingredient_block_innerside_innerlists_new");

    containers.forEach(container => {
      const title = container.querySelector(".Ingredient_block_innerside_innerlists_maintitle_new");
      const innerTitle = container.querySelector(".Ingredient_block_innerside_innerlists_innertitle_new");
      const tabLinks = container.querySelectorAll(".tablinks");

      if (!title) return;

      // Toggle on title click
      title.addEventListener("click", function (e) {
        e.stopPropagation();

        const isOpen = container.classList.contains("open");

        containers.forEach(c => c.classList.remove("open"));

        if (!isOpen) {
          container.classList.add("open");
        }
      });

      // Tab click → update text + close
      tabLinks.forEach(link => {
        link.addEventListener("click", function (e) {
          e.stopPropagation();

          // Update inner title text
          if (innerTitle) {
            innerTitle.textContent = link.textContent.trim();
          }

          container.classList.remove("open");
        });
      });
    });

    // Click outside → close all
    document.addEventListener("click", function (e) {
      document.querySelectorAll(".Ingredient_block_innerside_innerlists_new").forEach(container => {
        if (!container.contains(e.target)) {
          container.classList.remove("open");
        }
      });
    });
  }

  if (isMobile.matches) {
    initMobileBehavior();
  }

  isMobile.addEventListener("change", function (e) {
    if (e.matches) {
      initMobileBehavior();
    }
  });
});